import { render, staticRenderFns } from "./topSearch.vue?vue&type=template&id=b8a013cc&scoped=true"
import script from "./topSearch.vue?vue&type=script&lang=js"
export * from "./topSearch.vue?vue&type=script&lang=js"
import style0 from "./topSearch.vue?vue&type=style&index=0&id=b8a013cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a013cc",
  null
  
)

export default component.exports